import { render, staticRenderFns } from "./ModalMovement.vue?vue&type=template&id=29514146&"
import script from "./ModalMovement.vue?vue&type=script&lang=js&"
export * from "./ModalMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports